<template>
    <div>
        <v-card class="ma-4 py-3 px-5" style="background-color: #5D327C; color: #ffffff;">
            <p class="pt-3 pb-0 px-2">Billing information (including VAT)</p>
            <v-card class="mb-3">
                <v-card-text>
                    <v-row>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field type="number" label="Monthly fee (£)" v-model="clientBilling.monthlyFee"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field type="number" label="Acquired fee (£)" v-model="clientBilling.acquiredFee"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field type="number" label="Gifted fee (£)" v-model="clientBilling.giftedFee"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field type="number" label="We take from premium (£)" v-model="clientBilling.weTakeFromPremium"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-btn elevation="0" @click="updateBilling" color="primary" block class="button-style mt-3"> 
                                Update Information
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-card>
    </div>
</template>
<script>
import moment from 'moment'
import { Chrome } from 'vue-color'
import { VueEditor } from 'vue2-editor'
    export default {
        name: 'ClientBilling',
        data(){
            return {
                id: this.$route.params.id,
                client: {},
                clientBilling: {}
            }
        },
        methods: {
            getClient(){
                firebase.firestore().collection('clients').doc(this.id).collection('billing').doc('payment-settings').onSnapshot(docSnapshot => {
                    this.clientBilling = docSnapshot.data()
                }, err => { console.log(`Encountered error: ${err}`) })
            },
            updateBilling(){
                firebase.firestore().collection('clients').doc(this.id).collection('billing').doc('payment-settings').update({
                    monthlyFee: this.clientBilling.monthlyFee,
                    acquiredFee: this.clientBilling.acquiredFee,
                    giftedFee: this.clientBilling.giftedFee,
                    weTakeFromPremium: this.clientBilling.weTakeFromPremium
                })
            }
        },
        mounted(){
            this.getClient()
        }
    }
</script>
<style>
</style>